import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function OrdenesCorteCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];

  const [pedidos, setPedidos] = useState([]);
  const [selectedPedido, setSelectedPedido] = useState("");
  const [idArticulo, setIdArticulo] = useState("");
  const [value, setValue] = useState("");
  const [cliente, setCliente] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [numero, setNumero] = useState("NA");
  // (2026-10) subárea del cliente; sale entre paréntesis junto al cliente
  const [subArea, setSubArea] = useState("NA");
  const [total_piezas, setTotalPiezas] = useState(0);

  const [articulosPedido, setArticulosPedido] = useState([]);
  const [fecha_pedido, setFechaPedido] = useState("");
  // (2026-10) fecha de cancelación como venía en el pedido, para saber si la
  // cambiaron aquí y actualizarla en el pedido al guardar la orden
  const [fechaPedidoOriginal, setFechaPedidoOriginal] = useState("");
  const [total_piezas_pedido, setTotalPiezasPedido] = useState(0);
  const [total_general_pedido, setTotalGeneralPedido] = useState(0);

  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      cantidad: 0,
      idArticulosPedido: "",
      idArticulo: "",
      arrayColoresArticulo: [],
      tc: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL_PEDIDOS}OrdenCorte`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setPedidos(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [URL_PEDIDOS]);

  const finalizarOrden = (id, numeroCreado) => {
    axios
      .post(
        URL_LOGS,
        {
          tipo: "Crear Orden de Produccion",
          detalle: `${id}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire(
          "Good job!",
          `Creado con éxito, Orden Corte ${numeroCreado}`,
          "success"
        );
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error al registrar el log",
          footer: `${error.response?.data || error.message}`,
        });
        setValidaBoton(true);
      });
  };

  const saveOrdenCorte = async (event) => {
    event.preventDefault();

    if (fecha === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Faltan Datos",
      });
      return;
    }

    setValidaBoton(false);
    toggleProgreso();

    try {
      const { data } = await axios.post(
        URL_ORDENES_CORTE,
        {
          fecha,
          pedidos: selectedPedido,
          cantidad: total_piezas,
          observaciones,
          numero,
          subArea: String(subArea || "").trim() || "NA",
          cortado: "No",
          articulos: idArticulo,
          corteExterno: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // (2026-10) Si cambiaron la fecha de cancelación, se actualiza en el pedido
      const nuevaFecha = String(fecha_pedido || "").slice(0, 10);
      const fechaAnterior = String(fechaPedidoOriginal || "").slice(0, 10);
      if (nuevaFecha && nuevaFecha !== fechaAnterior) {
        const headers = {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        };
        try {
          await axios.patch(
            `${URL_PEDIDOS}/${selectedPedido}`,
            { fecha_cancelacion: nuevaFecha },
            { headers }
          );
          const numPedido =
            pedidos.find((p) => p._id === selectedPedido)?.idPedido || "";
          axios
            .post(
              URL_LOGS,
              {
                tipo: "Fecha Cancelacion Pedido",
                detalle: `Pedido ${numPedido}: ${fechaAnterior} → ${nuevaFecha} (desde Orden de Producción)`,
                user: user.id,
              },
              { headers }
            )
            .catch((err) => console.log(err));
        } catch (err) {
          console.error(err);
          Swal.fire(
            "Atención",
            "La orden se va a guardar, pero no se pudo actualizar la fecha de cancelación del pedido.",
            "warning"
          );
        }
      }

      let totalCombinaciones = 0;

      inputFields.forEach((field) => {
        (field.tc || []).forEach((item) => {
          if (Number(item.cantidad) > 0) {
            totalCombinaciones++;

            axios
              .post(
                URL_ARTICULOS_ORDENES_CORTE,
                {
                  ordenesCorte: data._id,
                  cantidad: parseFloat(item.cantidad),
                  articulos: item.idArticulo,
                  colores: item.idColor,
                  tallas: item.idTalla,
                  pendiente_cortar: parseFloat(item.cantidad),
                  cortado: 0,
                  pedidos: selectedPedido,
                  areasClientes: item.idAreasClientes,
                  // articulosPedido: item.idArticulosPedido || "",
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then(() => {
                totalCombinaciones--;
                if (totalCombinaciones === 0) {
                  finalizarOrden(data._id, data.numero);
                }
              })
              .catch((error) => {
                console.error(error);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Error guardando combinación",
                  footer: `${error.response?.data || error.message}`,
                });
                setValidaBoton(true);
              });
          }
        });
      });

      if (totalCombinaciones === 0) {
        finalizarOrden(data._id, data.numero);
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error al crear la Orden de Producción",
        footer: `${error.response?.data || error.message}`,
      });
      setValidaBoton(true);
    }
  };

function BuscaArticulo(id, event) {
  const idArticuloSeleccionado = event.target.value;
  setIdArticulo(idArticuloSeleccionado);

  const articulosDelArticulo = articulosPedido.filter(
    (a) => String(a.idArticulo) === String(idArticuloSeleccionado)
  );

  if (articulosDelArticulo.length === 0) return;

  // Colores únicos
  const colorMap = new Map();
  const coloresUnicos = [];
  articulosDelArticulo.forEach((a) => {
    if (!colorMap.has(String(a.idColor))) {
      colorMap.set(String(a.idColor), true);
      coloresUnicos.push({
        _id: a.idColor,
        name: a.color,
      });
    }
  });

  // Agrupar por: area + articulo + talla + color
  const agrupadoMap = new Map();

  articulosDelArticulo.forEach((a) => {
    const key = [
      String(a.idAreasClientes || ""),
      String(a.idArticulo || ""),
      String(a.idTalla || ""),
      String(a.idColor || ""),
    ].join("||");

    if (!agrupadoMap.has(key)) {
      agrupadoMap.set(key, {
        idArticulo: a.idArticulo,
        articuloNombre: a.articuloNombre,
        color: a.color,
        idColor: a.idColor,
        talla: a.talla,
        idTalla: a.idTalla,
        cantidad: parseFloat(a.cantidad || 0),
        areasClientes: a.areasClientes,
        idAreasClientes: a.idAreasClientes,
        idArticulosPedido: a._id ? [a._id] : [],
      });
    } else {
      const existente = agrupadoMap.get(key);
      existente.cantidad =
        parseFloat(existente.cantidad || 0) + parseFloat(a.cantidad || 0);

      if (a._id) {
        existente.idArticulosPedido.push(a._id);
      }
    }
  });

  const combinaciones = Array.from(agrupadoMap.values());

  const total = combinaciones.reduce(
    (sum, a) => sum + parseFloat(a.cantidad || 0),
    0
  );
  setTotalPiezas(total);

  const nuevos = [...inputFields];
  const index = nuevos.findIndex((f) => f.id === id);

  if (index !== -1) {
    nuevos[index].idArticulo = idArticuloSeleccionado;
    nuevos[index].arrayColoresArticulo = coloresUnicos;
    nuevos[index].tc = combinaciones;
    setInputFields(nuevos);
  }

  handleChangeInputArticulo(id, idArticuloSeleccionado);
}

  const handleChangeInputArticulo = (id, idArticuloNuevo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        return {
          ...i,
          idArticulo: idArticuloNuevo,
        };
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  function jalaPedido(e) {
    setSelectedPedido(e);

    axios
      .get(`${URL_ARTICULOS_PEDIDO}/pedidos/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosPedido = res.data;

        const arrayTabla = allArticulosPedido.map((a) => {
          const talla = a.tallas?.[0];
          const variante = talla?.variantesTallas?.[0];

          return {
            _id: a._id,
            idArticulo: a.articulos?.[0]?._id,
            // (2026-08) Sin el código de cliente: el selector se ordena por este
            // texto y el codigoCliente al frente mandaba los artículos a otro lado
            // de la lista (ej. 8539 salía como "039 8539").
            articuloNombre: `${a.articulos?.[0]?.codigo || ""} ${
              a.articulos?.[0]?.descripcion || ""
            }`.trim(),
            talla: talla
              ? `${talla.name}${variante?.name ? " " + variante.name : ""}`
              : "Sin Talla",
            idTalla: a.tallas?.[0]?._id,
            color: a.colores?.[0]?.name,
            idColor: a.colores?.[0]?._id,
            cantidad: a.cantidad,
            cantidadPedido: a.cantidad,
            areasClientes: a.areasClientes?.[0]?.name,
            idAreasClientes: a.areasClientes?.[0]?._id,
            idArticulosPedido: a._id,
          };
        });

        const dataFinal = Object.values(arrayTabla);
        setArticulosPedido(dataFinal);
        setIdArticulo(dataFinal?.[0]?.idArticulo || "");

        const TM = dataFinal.reduce(
          (t, c) => t + parseFloat(c.cantidad || 0),
          0
        );
        setTotalPiezas(TM);

        const agrupado = dataFinal.reduce((groups, item) => {
          const val = item.idArticulo;
          if (!groups[val]) groups[val] = { idArticulo: item.idArticulo };
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, {});

        setArticulosUnicos(Object.values(agrupado));
      })
      .catch((err) => console.log(err));

    const pedidoSel = pedidos.find((a) => a._id === e);
    if (pedidoSel) {
      setFechaPedido(pedidoSel.fecha_cancelacion);
      setFechaPedidoOriginal(pedidoSel.fecha_cancelacion);
      setFechaCompromiso(pedidoSel.fecha_compromiso);
      setTotalPiezasPedido(pedidoSel.total_piezas);
      setTotalGeneralPedido(pedidoSel.total_general);
      setCliente(pedidoSel.clientes?.[0]?.nombre_comercial);
      setIdCliente(pedidoSel.clientes?.[0]?._id);
      setObservaciones(pedidoSel.observaciones || "");
    }
  }

const handleChangeInputCantidad = (inputFieldId, idColor, idTalla, idArea, event) => {
  const nuevos = [...inputFields];
  const index = nuevos.findIndex((f) => f.id === inputFieldId);

  if (index !== -1) {
    nuevos[index].tc = (nuevos[index].tc || []).map((a) => {
      if (
        String(a.idColor) === String(idColor) &&
        String(a.idTalla) === String(idTalla) &&
        String(a.idAreasClientes) === String(idArea) // 👈 AQUÍ LA CLAVE
      ) {
        return {
          ...a,
          cantidad: parseFloat(event.target.value) || 0,
        };
      }
      return a;
    });

    setInputFields(nuevos);

    const totalGeneral = nuevos.reduce((acc, field) => {
      const totalField = (field.tc || []).reduce(
        (sum, item) => sum + parseFloat(item.cantidad || 0),
        0
      );
      return acc + totalField;
    }, 0);

    setTotalPiezas(totalGeneral);
  }
};

  const options = pedidos.map((option) => {
    const junta =
      option.idPedido + " " + (option.clientes?.[0]?.nombre_comercial || "");
    const firstLetter = option.idPedido?.toString() || "";

    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />

      {user.menu_produccion ? (
        <div className="card container col-10">
          <h3 align="center">Nueva Orden de Produccion</h3>

          <Form>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Pedido</Label>
                <Autocomplete
                  size="small"
                  value={value}
                  onChange={(event, selectedPedidoAuto) => {
                    if (selectedPedidoAuto) {
                      setValue(selectedPedidoAuto);
                      jalaPedido(selectedPedidoAuto._id);
                    } else {
                      setValue("");
                    }
                  }}
                  options={options.sort((a, b) =>
                    -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.idPedido}{" "}
                      {option.clientes?.[0]?.nombre_comercial || ""}
                    </React.Fragment>
                  )}
                />
              </Col>

              <Col md={3}>
                <Label>Fecha Cancelacion</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha_pedido}
                  required
                  onChange={(e) => {
                    setFechaPedido(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Cliente</Label>
                <Input
                  type="text"
                  placeholder="Cliente"
                  value={cliente}
                  required
                  disabled
                />
              </Col>

              <Col md={3}>
                <Label>Fecha Creacion Orden de Produccion</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  disabled
                />
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Numero</Label>
                <Input
                  type="text"
                  placeholder="Numero"
                  value={numero}
                  required
                  onChange={(e) => {
                    setNumero(e.target.value);
                  }}
                />
              </Col>

              <Col md={6}>
                <Label className="mr-sm-2">Observaciones</Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label className="mr-sm-2">Subárea</Label>
                <Input
                  type="text"
                  placeholder="Subárea"
                  value={subArea}
                  onChange={(e) => {
                    setSubArea(e.target.value);
                  }}
                />
              </Col>

              <Col md={6}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                  pzas.
                </h4>
              </Col>
            </Row>

            <br />

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
            </Row>

{inputFields.map((inputField) => {
  const dataAgrupada = {};

  if (Array.isArray(inputField.tc)) {
    inputField.tc.forEach((item) => {
      const area = item.areasClientes || "Sin área";
      const articulo = item.articuloNombre || "Sin artículo";
      const color = item.color || "Sin color";

      if (!dataAgrupada[area]) dataAgrupada[area] = {};
      if (!dataAgrupada[area][articulo]) dataAgrupada[area][articulo] = {};
      if (!dataAgrupada[area][articulo][color]) dataAgrupada[area][articulo][color] = [];

      dataAgrupada[area][articulo][color].push(item);
    });
  }

  return (
    <div key={inputField.id} className="mb-4">
      <Row>
        <Col md={3}>
          <Input
            bsSize="sm"
            name="idArticulo"
            type="select"
            value={inputField.idArticulo}
            onChange={(event) => {
              BuscaArticulo(inputField.id, event);
            }}
          >
            <option value="">Selecciona un Articulo</option>
            {articulosUnicos
              .sort((a, b) => (a.articuloNombre > b.articuloNombre ? 1 : -1))
              .map((a) => (
                <option key={a.idArticulo} value={a.idArticulo}>
                  {a.articuloNombre}
                </option>
              ))}
          </Input>
        </Col>
      </Row>

      <br />

      {Object.entries(dataAgrupada).map(([area, articulos]) => (
        <div key={area} className="mb-4">
          <h5 style={{ fontWeight: "700", color: "#2f4f4f" }}>
            Área: {area}
          </h5>

          {Object.entries(articulos).map(([articuloNombre, colores]) => (
            <div key={articuloNombre} className="mb-4">
              <h6 style={{ fontWeight: "700", color: "#000" }}>
                {articuloNombre}
              </h6>

              {Object.entries(colores).map(([colorNombre, items]) => {
                const itemsOrdenados = [...items].sort((a, b) => {
                  const baseA = (a.talla || "").split(" ")[0];
                  const baseB = (b.talla || "").split(" ")[0];
                  const indexA = ordenTallas.indexOf(baseA);
                  const indexB = ordenTallas.indexOf(baseB);

                  return (
                    (indexA === -1 ? Infinity : indexA) -
                    (indexB === -1 ? Infinity : indexB)
                  );
                });

                const totalColor = itemsOrdenados.reduce(
                  (sum, item) => sum + (parseFloat(item.cantidad) || 0),
                  0
                );

                return (
                  <div
  key={`${area}_${articuloNombre}_${colorNombre}`}
  className="mb-4"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    flexWrap: "wrap",
    borderBottom: "1px solid #dee2e6",
    paddingBottom: "12px",
    marginBottom: "12px",
  }}
>
                    <div
                      style={{
                        minWidth: "190px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "800",
                          fontSize: "18px",
                          color: "#557c55",
                          textTransform: "uppercase",
                        }}
                      >
                        {colorNombre}
                      </div>
                      <div
                        style={{
                          fontSize: "15px",
                          color: "#6c757d",
                        }}
                      >
                        Total color:{" "}
                        <strong>{new Intl.NumberFormat("en-US").format(totalColor)}</strong>
                      </div>
                    </div>

                    <div
                      className="d-flex flex-wrap"
                      style={{
                        gap: "24px",
                        flex: 1,
                      }}
                    >
                      {itemsOrdenados.map((a) => (
                        <div
                          key={`${a.idAreasClientes}_${a.idArticulo}_${a.idTalla}_${a.idColor}`}
                          className="text-center"
                          style={{
                            minWidth: "88px",
                          }}
                        >
                          <Label
                            style={{
                              color: "#314a7d",
                              fontWeight: "600",
                              marginBottom: "6px",
                              display: "block",
                            }}
                          >
                            {a.talla}
                          </Label>

                          <Input
                            bsSize="sm"
                            type="number"
                            value={a.cantidad}
                            onChange={(event) =>
  handleChangeInputCantidad(
    inputField.id,
    a.idColor,
    a.idTalla,
    a.idAreasClientes, // 👈 nuevo parámetro
    event
  )
}
                            style={{
                              width: "84px",
                              textAlign: "center",
                              margin: "0 auto",
                              borderRadius: "10px",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
})}

            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                  pzas
                </h4>
              </Col>
            </Row>
          </Form>

          <br />

          <Row>
            <Col>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabIndex="-1"
                  onClick={saveOrdenCorte}
                >
                  Guardar
                </Button>
              ) : (
                <Button
                  type="submit"
                  className="btn btn-success"
                  disabled
                  tabIndex="-1"
                >
                  Guardar
                </Button>
              )}

              <Button
                href="/ListadoOrdenesCorte"
                className="btn btn-danger"
                id="botonListado"
                tabIndex="-1"
              >
                Regresar
              </Button>
            </Col>
          </Row>

          <br />

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCorteCreate;